import type { Notification } from '../@types/user';
import type { AppDispatch } from '../redux/store';
import { acceptInvitation, declineInvitation } from '../features/invitation/api';
import { NotificationTypes } from './notificationTypes';

type NotificationActionConfig = {
  labelKey: string;
  variant: 'contained' | 'outlined';
  color: 'primary' | 'inherit';
  successKey: string;
  errorKey: string;
  handle: (notification: Notification, dispatch: AppDispatch) => Promise<void>;
};

export const NOTIFICATION_ACTIONS: Record<string, NotificationActionConfig[]> = {
  [NotificationTypes.PathwayInvitation]: [
    {
      labelKey: 'components.inbox_popover.accept',
      variant: 'contained',
      color: 'primary',
      successKey: 'components.inbox_popover.invitation_accepted',
      errorKey: 'components.inbox_popover.invitation_error',
      handle: async (notification, dispatch) => {
        await dispatch(acceptInvitation(notification.referenceGuid!));
      }
    },
    {
      labelKey: 'components.inbox_popover.decline',
      variant: 'outlined',
      color: 'inherit',
      successKey: 'components.inbox_popover.invitation_declined',
      errorKey: 'components.inbox_popover.invitation_error',
      handle: async (notification, dispatch) => {
        await dispatch(declineInvitation(notification.referenceGuid!));
      }
    }
  ]
};

// Derived automatically — no need to maintain separately
export const NOTIFICATION_TYPES_WITH_ACTIONS = new Set(Object.keys(NOTIFICATION_ACTIONS));
